import { render } from "./ImportCSVLoader2.vue?vue&type=template&id=1996b628&scoped=true"
import script from "./ImportCSVLoader2.vue?vue&type=script&lang=js"
export * from "./ImportCSVLoader2.vue?vue&type=script&lang=js"

import "./ImportCSVLoader2.vue?vue&type=style&index=0&id=1996b628&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1996b628"]])

export default __exports__